module.exports = __webpack_public_path__ + "static/media/empty-item.444bc5edeb670a87bb86e117b0f8bf11.svg";